<script>
import axios from 'axios'
export default {
  props: {
    attachmentId: {
      type: [Number, String],
      required: true,
    },
    attachments: {
      type: Array,
      default: null,
    },
    src: {
      type: String,
      required: false,
      default: null,
    },
    resource: {
      type: String,
      required: false,
      default: null,
    },
    recipientId: {
      type: Number,
      required: false,
      default: null,
    },
    urlsym: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      url: '',
    }
  },
  async mounted() {
    this.loading = true
    let data
    if (!this.urlsym) {
      if (this.resource === 'unauth') {
        await axios
          .post(`/api/v1/library/shared/hr/files/`, {
            file_id: this.attachmentId,
            recipient_information_id: this.recipientId,
          })
          .then(
            (res) => {
              data = res
            },
            (err) => {
              console.warn(err, err.response.data)
              this.loading = false
            }
          )
      } else if (this.resource === 'vault') {
        // eslint-disable-next-line dot-notation
        data = {
          data: {
            url: this.src,
          },
        }
      } else {
        data = await axios.get(`/api/v1/library/files/${this.attachmentId}`)
      }
      this.url = data.data.url
      this.loading = false
    } else {
      await axios
        .post(`/api/v1/symptom-checker/get_document`, {
          document_id: this.attachmentId,
        })
        .then(
          (res) => {
            this.loading = false

            this.url = res.data.file_url
          },
          (err) => {
            console.warn(err, err.response.data)
            this.loading = false
          }
        )
    }
  },
  methods: {
    closeOverlay() {
      this.$emit('closeOverlay')
    },
  },
}
</script>

<template>
  <v-card
    v-if="!loading"
    v-click-outside="closeOverlay"
    :class="$style.attachmentCard"
    width="100%"
  >
    <v-card-title>
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <v-btn text fab class="ml-2" @click="$emit('closeOverlay')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card-title>
    <v-card-text class="mt-2">
      <v-row justify="center" :class="$style.attachmentRowPdf">
        <object :data="url" type="application/pdf" width="100%" height="100%">
          <div>No online PDF viewer installed</div>
        </object>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<style lang="scss" module>
@import '@design';
.attachmentCard {
  opacity: 0.98;
}
.attachmentRowPdf {
  height: 80vh;
}
</style>
